import { Button } from "primereact/button";
import Footer from "../components/Footer";
import Gallery from "../components/Gallery";
import Navbar from "../components/NavBar";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import TestimoniosGallery from "../components/TestimoniosGallery";
import { useNavigate } from "react-router-dom";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import React, { useState } from "react";

export default function Inicio() {
  const navigate = useNavigate();

  const CheckItem = ({ children }) => (
    <div className="flex align-items-start gap-2 mb-2">
      <i
        className="pi pi-check-square"
        style={{ color: "#2ecc71", fontSize: 18, marginTop: 3 }}
        aria-hidden
      />
      <span style={{ color: "#fff", lineHeight: 1.6 }}>{children}</span>
    </div>
  );

  const [formData, setFormData] = useState({
    nombreCompleto: "",
    correo: "",
    celular: "",
    telefonoFijo: "",
    preparatoria: "",
    preguntas: "",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleWhatsAppSubmit = () => {
    const {
      nombreCompleto,
      correo,
      celular,
      telefonoFijo,
      preparatoria,
      preguntas,
    } = formData;

    if (!nombreCompleto.trim() || !correo.trim() || !celular.trim()) {
      alert(
        "Por favor completa al menos Nombre Completo, Correo Electrónico y Número de Celular.",
      );
      return;
    }

    const numeroWhatsApp = "5219651007363";

    const mensaje = `Hola, solicito más información sobre la Licenciatura en Marketing Digital de la UNICACH.

Nombre completo: ${nombreCompleto}
Correo electrónico: ${correo}
Número de celular: ${celular}
Número de teléfono fijo: ${telefonoFijo || "No proporcionado"}
Preparatoria de egreso: ${preparatoria || "No proporcionada"}
Preguntas o inquietudes: ${preguntas || "Sin preguntas adicionales"}`;

    const url = `https://wa.me/${numeroWhatsApp}?text=${encodeURIComponent(mensaje)}`;

    window.open(url, "_blank");
  };

  return (
    <div className="app-root">
      <Navbar />

      <main className="w-full">
        {/* ===== HERO SLIDER (tu Galleria) ===== */}
        <Gallery />

        {/* ===== BARRA DE ESTADÍSTICAS ===== */}
        <section className="w-full" style={{ background: "#ffffff" }}>
          <div
            className="grid p-3 md:p-4 lg:p-5"
            style={{ maxWidth: 1200, margin: "0 auto" }}
          >
            {/* Graduados */}
            <div className="col-12 sm:col-6 md:col-3 flex align-items-center gap-3">
              <i
                className="pi pi-graduation-cap"
                style={{ fontSize: 32, color: "#F2933F" }}
              />
              <div>
                <div style={{ fontWeight: 800, fontSize: 24, lineHeight: 1 }}>
                  80+
                </div>
                <div style={{ opacity: 0.85 }}>Graduados</div>
              </div>
            </div>

            {/* Estudiantes */}
            <div className="col-12 sm:col-6 md:col-3 flex align-items-center gap-3">
              <i
                className="pi pi-users"
                style={{ fontSize: 32, color: "#F2933F" }}
              />
              <div>
                <div style={{ fontWeight: 800, fontSize: 24, lineHeight: 1 }}>
                  200+
                </div>
                <div style={{ opacity: 0.85 }}>Estudiantes</div>
              </div>
            </div>

            {/* Docentes */}
            <div className="col-12 sm:col-6 md:col-3 flex align-items-center gap-3">
              <i
                className="pi pi-flag"
                style={{ fontSize: 32, color: "#F2933F" }}
              />
              <div>
                <div style={{ fontWeight: 800, fontSize: 24, lineHeight: 1 }}>
                  20+
                </div>
                <div style={{ opacity: 0.85 }}>Docentes</div>
              </div>
            </div>

            {/* Premios */}
            <div className="col-12 sm:col-6 md:col-3 flex align-items-center gap-3">
              <i
                className="pi pi-star"
                style={{ fontSize: 32, color: "#F2933F" }}
              />
              <div>
                <div style={{ fontWeight: 800, fontSize: 24, lineHeight: 1 }}>
                  1+
                </div>
                <div style={{ opacity: 0.85 }}>Premios</div>
              </div>
            </div>
          </div>

          <div
            className="flex justify-content-center pb-3"
            style={{ color: "#1a3e5f" }}
          >
            <small>
              VALIDEZ OFICIAL ANTE LA SEP CCT <b>07ESU0016A</b>
            </small>
          </div>
        </section>

        {/* ===== SECCIÓN PROGRAMA (HERO TEXTO + IMAGEN) ===== */}
        <section className="w-full" style={{ background: "#ffffff" }}>
          <div
            className="grid align-items-center"
            style={{ maxWidth: 1200, margin: "0 auto", padding: "2rem 1rem" }}
          >
            {/* Col izquierda: imagen */}
            <div className="col-12 md:col-5 flex justify-content-center">
              <div
                className="flex justify-content-center align-items-center"
                style={{ width: "100%", maxWidth: 440 }}
              >
                {/* coloca tu imagen en /public/images/alumno.png */}
                <img
                  src={`${process.env.PUBLIC_URL}/images/Estudiante.png`}
                  alt="Alumno"
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              </div>
            </div>

            {/* Col derecha: textos + CTAs */}
            <div className="col-12 sm:col-6 md:col-7">
              <div
                style={{ color: "#F2933F", fontWeight: 800, marginBottom: 6 }}
              >
                ¿TE QUIERES CONVERTIR EN UN PROFESIONAL
              </div>
              <h2
                style={{
                  color: "#0f3b63",
                  fontWeight: 900,
                  marginTop: 0,
                  marginBottom: 16,
                }}
              >
                DEL MARKETING DIGITAL?
              </h2>

              <p
                style={{ lineHeight: 1.7, color: "#253B53", marginBottom: 12 }}
              >
                <b>Esta licenciatura es tu mejor opción.</b> Con nosotros
                aprenderás a utilizar diferentes herramientas para generar
                estrategias de marketing enfocadas a objetivos específicos como
                atraer nuevos clientes, posicionar tu marca, analizar campañas
                enfocadas a las redes sociales, medir resultados, conocer qué es
                un ecosistema digital y los medios digitales.
              </p>

              <p
                style={{ lineHeight: 1.7, color: "#253B53", marginBottom: 12 }}
              >
                Garantizamos tu competitividad profesional trabajando con
                responsabilidad, eficiencia y creatividad a través de la
                disciplina, autonomía y confianza.
              </p>

              <p
                style={{ lineHeight: 1.7, color: "#253B53", marginBottom: 12 }}
              >
                Solo necesitas un equipo de cómputo con conexión a internet y
                conocimientos básicos en el uso de herramientas digitales.
              </p>

              <p
                style={{ lineHeight: 1.7, color: "#F2933F", marginBottom: 20 }}
              >
                Plataforma virtual 24/7 y con acceso a todo el contenido
                educativo a través de nuestro campus virtual.
              </p>

              <div className="flex flex-wrap gap-2">
                <Button
                  label="Plan de Estudio"
                  icon="pi pi-book"
                  style={{
                    background: "#0f3b63",
                    borderColor: "#0f3b63",
                    borderRadius: 12,
                    padding: "0.75rem 1rem",
                  }}
                  onClick={() =>
                    window.open(
                      `${process.env.PUBLIC_URL}/docs/Plan_estudios.jpg`,
                      "_blank",
                    )
                  }
                />
                <Button
                  label="Convocatoria"
                  icon="pi pi-info-circle"
                  className="p-button-outlined"
                  style={{
                    borderColor: "#0f3b63",
                    color: "#0f3b63",
                    borderRadius: 12,
                    padding: "0.75rem 1rem",
                  }}
                  onClick={() =>
                    window.open(
                      `${process.env.PUBLIC_URL}/docs/CONVOCATORIA.pdf`,
                      "_blank",
                    )
                  }
                />
              </div>
            </div>
          </div>
        </section>

        {/* ===== SECCIÓN: Aprenderás / Beneficios ===== */}
        <section
          className="w-full"
          style={{ background: "#F4A261", padding: "3rem 1rem" }}
        >
          <div
            className="grid w-full align-items-start justify-content-center"
            style={{ maxWidth: 1200, margin: "0 auto" }}
          >
            {/* IZQUIERDA */}
            <div
              className="col-12 sm:col-6 md:col-6"
              style={{ paddingRight: "1rem" }}
            >
              <div
                style={{
                  color: "#fff",
                  fontWeight: 800,
                  letterSpacing: "0.5px",
                  opacity: 0.9,
                  marginBottom: 6,
                }}
              >
                AQUÍ
              </div>
              <h2
                style={{
                  color: "#0f3b63",
                  fontWeight: 900,
                  margin: 0,
                  marginBottom: 16,
                }}
              >
                APRENDERÁS A:
              </h2>

              <div>
                <CheckItem>Diseñar estrategias de marketing.</CheckItem>
                <CheckItem>Evaluar el impacto de campañas.</CheckItem>
                <CheckItem>Aplicar diferentes procesos a negocios.</CheckItem>
                <CheckItem>
                  Analizar el comportamiento del consumidor.
                </CheckItem>
                <CheckItem>Diseño Web.</CheckItem>
                <CheckItem>Desarrollar política informática.</CheckItem>
              </div>
            </div>

            {/* DERECHA */}
            <div
              className="col-12 sm:col-6 md:col-6"
              style={{ paddingLeft: "1rem" }}
            >
              <div
                style={{
                  color: "#fff",
                  fontWeight: 800,
                  letterSpacing: "0.5px",
                  opacity: 0.9,
                  marginBottom: 6,
                }}
              >
                ALGUNOS
              </div>
              <h2
                style={{
                  color: "#0f3b63",
                  fontWeight: 900,
                  margin: 0,
                  marginBottom: 16,
                }}
              >
                BENEFICIOS SON:
              </h2>

              <div>
                <CheckItem>Seguro médico facultativo.</CheckItem>
                <CheckItem>Acompañamiento docente.</CheckItem>
                <CheckItem>Tutorías durante toda la licenciatura.</CheckItem>
                <CheckItem>Apoyo en campus virtual.</CheckItem>
                <CheckItem>
                  Acceso a la biblioteca virtual de la UNICACH.
                </CheckItem>
                <CheckItem>
                  Servicios de psicología, odontología y nutrición… y más.
                </CheckItem>
              </div>
            </div>
          </div>
        </section>

        {/* ===== SECCIÓN: Lead / Formulario ===== */}
        <section
          id="formulario"
          className="w-full"
          style={{ background: "#ffffff", padding: "3rem 1rem" }}
        >
          <div
            className="grid w-full align-items-start"
            style={{ maxWidth: 1200, margin: "0 auto" }}
          >
            {/* Columna izquierda: título + texto + 3 inputs verticales */}
            <div className="col-12 md:col-6" style={{ paddingRight: "1rem" }}>
              <div
                style={{
                  color: "#F2933F",
                  fontWeight: 800,
                  letterSpacing: "0.5px",
                  marginBottom: 6,
                }}
              >
                ESTAS A UN PASO DE
              </div>
              <h2
                style={{
                  color: "#0f3b63",
                  fontWeight: 900,
                  margin: 0,
                  marginBottom: 12,
                }}
              >
                SER UN MARKETERO PROFESIONAL
              </h2>
              <p
                style={{ color: "#253B53", lineHeight: 1.6, marginBottom: 24 }}
              >
                📢 ¡El futuro del marketing está en tus manos! Si quieres
                dominar las estrategias digitales y potenciar tus habilidades,
                la Licenciatura en Marketing Digital de la UNICACH es para ti.{" "}
                <br />
                ¡Déjanos tus datos y recibe más información de tu futuro
                profesional! 🌐📚
              </p>

              <div className="flex flex-column gap-3" style={{ maxWidth: 560 }}>
                <span style={{ width: "100%" }}>
                  <IconField iconPosition="left">
                    <InputIcon className="pi pi-user"> </InputIcon>
                    <InputText
                      value={formData.nombreCompleto}
                      onChange={(e) =>
                        handleChange("nombreCompleto", e.target.value)
                      }
                      placeholder="Nombre Completo"
                      className="w-full"
                      style={{
                        borderRadius: 999,
                        borderColor: "#E49B3C",
                      }}
                    />
                  </IconField>
                </span>

                <span className="p-input-icon-left" style={{ width: "100%" }}>
                  <i className="pi pi-" />
                  <IconField iconPosition="left">
                    <InputIcon className="pi pi-envelope"> </InputIcon>
                    <InputText
                      type="email"
                      value={formData.correo}
                      onChange={(e) => handleChange("correo", e.target.value)}
                      placeholder="Correo Electrónico"
                      className="w-full"
                      style={{
                        borderRadius: 999,
                        borderColor: "#E49B3C",
                      }}
                    />
                  </IconField>
                </span>

                <span className="p-input-icon-left" style={{ width: "100%" }}>
                  <IconField iconPosition="left">
                    <InputIcon className="pi pi-phone"> </InputIcon>
                    <InputText
                      value={formData.celular}
                      onChange={(e) => handleChange("celular", e.target.value)}
                      placeholder="Número de Celular"
                      className="w-full"
                      style={{
                        borderRadius: 999,
                        borderColor: "#E49B3C",
                      }}
                    />
                  </IconField>
                </span>

                <span className="p-input-icon-left" style={{ width: "100%" }}>
                  <IconField iconPosition="left">
                    <InputIcon className="pi pi-phone"> </InputIcon>
                    <InputText
                      value={formData.telefonoFijo}
                      onChange={(e) =>
                        handleChange("telefonoFijo", e.target.value)
                      }
                      placeholder="Número de Teléfono Fijo"
                      className="w-full"
                      style={{
                        borderRadius: 999,
                        borderColor: "#E49B3C",
                      }}
                    />
                  </IconField>
                </span>
              </div>
            </div>

            {/* Columna derecha: preparatoria + textarea + botón enviar */}
            <div className="col-12 md:col-6" style={{ paddingLeft: "1rem" }}>
              <div
                className="flex flex-column gap-3"
                style={{ maxWidth: 560, marginLeft: "auto" }}
              >
                <InputText
                  value={formData.preparatoria}
                  onChange={(e) => handleChange("preparatoria", e.target.value)}
                  placeholder="¿De qué preparatoria egresaste?"
                  className="w-full"
                  style={{
                    borderRadius: 999,
                    borderColor: "#E49B3C",
                  }}
                />
                <InputTextarea
                  value={formData.preguntas}
                  onChange={(e) => handleChange("preguntas", e.target.value)}
                  placeholder="¿Tienes alguna pregunta o inquietud sobre la licenciatura?"
                  rows={10}
                  autoResize
                  className="w-full"
                  style={{
                    borderRadius: 24,
                    borderColor: "#E49B3C",
                  }}
                />
                <div className="flex justify-content-end">
                  <Button
                    label="ENVIAR"
                    icon="pi pi-send"
                    type="button"
                    style={{
                      background: "#0f3b63",
                      borderColor: "#0f3b63",
                      borderRadius: 999,
                      fontWeight: 700,
                    }}
                    onClick={handleWhatsAppSubmit}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          id="testimonios"
          className="w-full"
          style={{ background: "#fff", padding: "3rem 1rem" }}
        >
          <div
            className="grid align-items-center"
            style={{ maxWidth: 1200, margin: "0 auto" }}
          >
            {/* Texto (izquierda) */}
            <div className="col-12 md:col-6" style={{ paddingRight: "1rem" }}>
              <div
                style={{
                  color: "#F2933F",
                  fontWeight: 800,
                  letterSpacing: "0.5px",
                  marginBottom: 6,
                }}
              >
                VOCES QUE INSPIRAN
              </div>
              <h2
                style={{
                  color: "#0f3b63",
                  fontWeight: 900,
                  margin: 0,
                  marginBottom: 4,
                }}
              >
                EXPERIENCIA UNICACH 🎓
              </h2>
              <div
                style={{
                  color: "#99A4AF",
                  fontWeight: 700,
                  letterSpacing: "0.5px",
                  marginBottom: 20,
                }}
              >
                EXPERIENCIA UNICACH
              </div>

              <p
                style={{ color: "#6B7A8B", lineHeight: 1.8, marginBottom: 16 }}
              >
                No solo creamos profesionales para la vida, en UNICACH, formamos
                líderes con la capacidad de crear, innovar y analizar
                estrategias digitales para obtener resultados que se reflejan en
                lo político, económico, social y cultural.
              </p>
              <p style={{ color: "#6B7A8B", lineHeight: 1.8 }}>
                Tú puedes ser el próximo testimonio de éxito. 🚀
              </p>
            </div>

            {/* Galería (derecha) */}
            <div className="col-12 md:col-6" style={{ paddingLeft: "1rem" }}>
              <TestimoniosGallery
                videos={[
                  {
                    src: `${process.env.PUBLIC_URL}/images/videos/testimonios/VIDEO_ALFREDO.MP4`,
                    poster: `${process.env.PUBLIC_URL}/images/testimonio1-poster.jpg`,
                  },
                  {
                    src: `${process.env.PUBLIC_URL}/images/videos/testimonios/VIDEO_RAFAEL.MP4`,
                    poster: `${process.env.PUBLIC_URL}/images/testimonio2-poster.jpg`,
                  },
                  {
                    src: `${process.env.PUBLIC_URL}/images/videos/testimonios/VIDEO_SERGIO.MP4`,
                    poster: `${process.env.PUBLIC_URL}/images/testimonio3-poster.jpg`,
                  },
                  {
                    src: `${process.env.PUBLIC_URL}/images/videos/testimonios/VIDEO_TANIA_2023.mp4`,
                    poster: `${process.env.PUBLIC_URL}/images/testimonio3-poster.jpg`,
                  },
                  {
                    src: `${process.env.PUBLIC_URL}/images/videos/testimonios/VIDEO_ABRAHAM_2023.mp4`,
                    poster: `${process.env.PUBLIC_URL}/images/testimonio3-poster.jpg`,
                  },
                  {
                    src: `${process.env.PUBLIC_URL}/images/videos/testimonios/VIDEO_ARIADNA_2023.mp4`,
                    poster: `${process.env.PUBLIC_URL}/images/testimonio3-poster.jpg`,
                  },
                  {
                    src: `${process.env.PUBLIC_URL}/images/videos/testimonios/VIDEO_JUAN_ELÍ_2023.mp4`,
                    poster: `${process.env.PUBLIC_URL}/images/testimonio3-poster.jpg`,
                  },
                ]}
              />
            </div>
          </div>
        </section>

        {/* ===== CTA: ¿QUIERES SABER MÁS? ===== */}
        <section
          className="w-full"
          style={{
            padding: "2.5rem 1rem",
            background: "linear-gradient(90deg,#0f3b63 0%, #0a2e53 100%)",
          }}
        >
          <div
            className="grid align-items-center"
            style={{ maxWidth: 1200, margin: "0 auto" }}
          >
            {/* Texto + botón */}
            <div
              className="col-12 md:col-7"
              style={{ color: "#fff", paddingRight: "1rem" }}
            >
              <h2
                style={{
                  margin: 0,
                  marginBottom: 10,
                  fontWeight: 900,
                  letterSpacing: ".5px",
                }}
              >
                ¿QUIERES SABER MÁS?
              </h2>
              <p style={{ marginTop: 0, opacity: 0.95 }}>
                Da click al botón para conocer más sobre la licenciatura.
              </p>

              <Button
                label="Más información"
                onClick={() => navigate("/convocatoria")}
                style={{
                  background: "#F2933F",
                  borderColor: "#F2933F",
                  color: "#0f3b63",
                  fontWeight: 700,
                  borderRadius: 999,
                  padding: "0.9rem 1.4rem",
                }}
              />
            </div>

            {/* Logo a la derecha */}
            <div
              className="col-12 md:col-5 flex justify-content-end"
              style={{ paddingLeft: "1rem" }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/Logo.png`} /* coloca tu logo en /public/images/md_logo.png */
                alt="Lic. en Marketing Digital UNICACH"
                style={{
                  maxWidth: 280,
                  width: "100%",
                  height: "auto",
                  filter: "drop-shadow(0 6px 16px rgba(0,0,0,.15))",
                }}
              />
            </div>
          </div>
        </section>

        {/* ===== NUESTRAS REDES SOCIALES ===== */}
        <section
          className="w-full"
          style={{ background: "#fff", padding: "2.5rem 1rem" }}
        >
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <div
              style={{
                color: "#F2933F",
                fontWeight: 800,
                letterSpacing: ".5px",
                marginBottom: 6,
              }}
            >
              NUESTRAS
            </div>
            <h2
              style={{
                color: "#0f3b63",
                fontWeight: 900,
                marginTop: 0,
                marginBottom: 24,
              }}
            >
              REDES SOCIALES
            </h2>

            <div className="grid">
              {/* Facebook */}
              <div className="col-12 md:col-4 p-2">
                <a
                  href="https://facebook.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-column align-items-center justify-content-center w-full"
                  style={{
                    textDecoration: "none",
                    border: "3px solid #F3B067",
                    borderRadius: 16,
                    padding: "2rem 1rem",
                    transition: "all .2s ease",
                    color: "#0f3b63",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.boxShadow =
                      "0 10px 22px rgba(15,59,99,.12)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.boxShadow = "none")
                  }
                >
                  <i
                    className="pi pi-facebook"
                    style={{ fontSize: 64, color: "#0f3b63" }}
                  />
                  <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                    Facebook
                  </div>
                </a>
              </div>

              {/* Instagram */}
              <div className="col-12 md:col-4 p-2">
                <a
                  href="https://instagram.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-column align-items-center justify-content-center w-full"
                  style={{
                    textDecoration: "none",
                    border: "3px solid #F3B067",
                    borderRadius: 16,
                    padding: "2rem 1rem",
                    transition: "all .2s ease",
                    color: "#0f3b63",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.boxShadow =
                      "0 10px 22px rgba(15,59,99,.12)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.boxShadow = "none")
                  }
                >
                  <i
                    className="pi pi-instagram"
                    style={{ fontSize: 64, color: "#0f3b63" }}
                  />
                  <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                    Instagram
                  </div>
                </a>
              </div>

              {/* YouTube */}
              <div className="col-12 md:col-4 p-2">
                <a
                  href="https://youtube.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex flex-column align-items-center justify-content-center w-full"
                  style={{
                    textDecoration: "none",
                    border: "3px solid #F3B067",
                    borderRadius: 16,
                    padding: "2rem 1rem",
                    transition: "all .2s ease",
                    color: "#0f3b63",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.boxShadow =
                      "0 10px 22px rgba(15,59,99,.12)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.boxShadow = "none")
                  }
                >
                  <i
                    className="pi pi-youtube"
                    style={{ fontSize: 64, color: "#0f3b63" }}
                  />
                  <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                    Youtube
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
